import {
  CheckboxWithLabel,
  FileWithLabel,
  memoWithOpen,
  NumberFieldWithLabel,
  SimpleDialog
} from "../../components";
import {t} from "i18next";
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {useTaskQueue} from "../../hooks";
import {Grid} from "@material-ui/core";
import {lasFileFilter} from "../../file-extensions";
import {deleteAsset} from "../../redux/assets-slice";
import {addAssetFolder} from "../../utilities";

export const Sampling = memoWithOpen((props) => {
  const {assets, open, onClose} = props;
  const dispatch = useDispatch();
  const {addRunningTask} = useTaskQueue();

  const defaultSamplingRateOptions = {
    value: 40,
    error: false
  };

  const [outputPath, setOutputPath] = useState(null);
  const [samplingRate, setSamplingRate] = useState(defaultSamplingRateOptions);
  const [importResult, setImportResult] = useState(true);

  const validSampling = samplingRate.error === false && samplingRate.value !== null;
  const canSubmit = (outputPath !== null && validSampling);

  // TODO: actually handle multiple inputs (sent multiple exe commands to processing queue)
  const asset = assets ? assets[0] : undefined;

  const handleSubmit = () => {
    const pythonName = "sampling";
    const decimalSamplingRate = samplingRate.value/100;

    let commands = [
      "-p", pythonName,
      "--inputlas", asset.path,
      "--outputlas", outputPath,
      "--rate", decimalSamplingRate
    ];

    const onFinish = async () => {
      if (!importResult) return;

      // Remove old LAS
      dispatch(deleteAsset(asset.id));

      // Add new sampled LAS
      await addAssetFolder(dispatch, [outputPath], asset.folderID);
    };

    onClose();
    addRunningTask(commands, onFinish);
  };

  const resetDefaults = () => {
    setOutputPath(null);
    setSamplingRate(defaultSamplingRateOptions);
    setImportResult(true);
  };

  useEffect(() => {
    if (open) return;
    resetDefaults();
  }, [open]);

  return (
    <React.Fragment>
      <SimpleDialog
        open={open}
        onClose={onClose}
        onSubmit={handleSubmit}
        canSubmit={canSubmit}
        title={t('functions.sampling.title')}
        button={t('buttons.submit')}
      >
        <Grid container spacing={2}>

          {/** Sampling Rate */}
          <Grid item xs={6}>
            <NumberFieldWithLabel
              title={t('functions.sampling.sampling_rate')}
              label={t('functions.sampling.sampling_rate_description')}
              value={samplingRate}
              min={0}
              max={100}
              setData={setSamplingRate}
              data={samplingRate}
              adornment={"%"}
            />
          </Grid>

          {/** Import results */}
          <Grid item xs={6}>
            <CheckboxWithLabel
              title={t('functions.import_results')}
              label={t('functions.sampling.sampled_is_imported')}
              value={importResult}
              onChange={setImportResult}
            />
          </Grid>

          {/** Output LAS */}
          <Grid item xs={6}>
            <FileWithLabel
              title={t('functions.sampling.sampled_output_las')}
              label={t('functions.sampling.sampled_output_las_description')}
              filter={lasFileFilter}
              value={outputPath}
              onChange={setOutputPath}
              saveFile
            />
          </Grid>

        </Grid>
      </SimpleDialog>
    </React.Fragment>
  );
});
